
    import '/Users/lijixiang/Work/power-design/site/docs/flow-components/index.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-flow-components-demo-quickstart"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/flow-components/index.md?type=demo')
};